import { render } from "./ItemDetailsByChannelReport.vue?vue&type=template&id=0e3f728a&scoped=true"
import script from "./ItemDetailsByChannelReport.vue?vue&type=script&lang=js"
export * from "./ItemDetailsByChannelReport.vue?vue&type=script&lang=js"

import "./ItemDetailsByChannelReport.vue?vue&type=style&index=0&id=0e3f728a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3f728a"]])

export default __exports__